import BaseModal from '@/components/BaseModal/index.vue'

// @vue/component
export default {
  name: 'ConfirmModal',

  components: {
    BaseModal,
  },

  props: {
    /** Whether to disable focus trapping */
    noFocus: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove', 'close', 'hidden'],

  methods: {
    /**
     * Opens the confirm modal by calling the open method on the confirmModal reference.
     */
    open() {
      this.$refs.confirmModal.open()
    },

    /** Closes the confirm modal. */
    close() {
      this.$refs.confirmModal.close()
    },

    /** Emits remove event and closes the modal. */
    remove() {
      this.$emit('remove')
      this.close()
    },
  },
}
